// assets/custom-header.js

// === PANNPROFFSEN – Mobile Overlay Menu v4 (fullscreen + submenus) ======

(function () {

  const header = document.querySelector('.header-inner.fix');
  const mobileMenu = document.querySelector('[id^="oc-menu-msections-"][id$="__header"]');
  const hamburger = mobileMenu ? mobileMenu.querySelector('.oc-menu-bar') : null;
  let lastFocusEl = null;

  // 1) Sticky-färg
  function setHeaderState() {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 50);
  }
  ['DOMContentLoaded','load','resize','scroll','shopify:section:load','shopify:page:load']
    .forEach(evt => window.addEventListener(evt, setHeaderState, { passive: true }));
  setHeaderState();

  // 2) Bygg overlay (en gång)
  function buildOverlay() {
    if (document.getElementById('pp-menu-overlay')) return;

    const ov = document.createElement('div');
    ov.id = 'pp-menu-overlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-hidden', 'true');

    // Logga
    const logoEl = document.querySelector('#logo img, .logo-container img, header img[alt*="Pannproffsen"]');
    const logoSrc = logoEl ? logoEl.src : '';

    // Hämta meny från desktop-nav
    const desktopMenu = document.querySelector('.oc-menu.horizontal-menu');
    const topItems = desktopMenu ? Array.from(desktopMenu.querySelectorAll('.li-top-item')) : [];

    // Subtitle-map
    const subtitleMap = {
      'Hem':        'Tillbaka till start',
      'Produkter':  'Utforska vårt sortiment',
      'Kategorier': 'Utforska vårt sortiment',
      'Om oss':     'Vår historia & vision',
      'Kontakta':   'Hör av dig till oss',
      'FAQ':        'Vanliga frågor',
      'Blogg':      'Nyheter & tips',
    };

    // Helper – bygg en LI med ev. undermeny + subtitle
    const buildItem = (rootLi) => {
      const a = rootLi.querySelector('.a-top-link');
      if (!a) return '';
      const href = a.getAttribute('href') || '#';
      const title = a.textContent.trim();
      const subtitle = subtitleMap[title] || '';
      const subtitleHTML = subtitle
        ? `<span class="pp-menu-subtitle">${subtitle}</span>`
        : '';

      // Undermeny?
      const secondUl = rootLi.querySelector('.ul-second-items');
      if (!secondUl) {
        return `<li class="pp-item"><a class="pp-toplink" href="${href}"><div>${title}${subtitleHTML}</div></a></li>`;
      }

      // Har children → accordion
      const subLinks = Array.from(secondUl.querySelectorAll('a')).map(sA => {
        const sHref = sA.getAttribute('href') || '#';
        const sTitle = sA.textContent.trim();
        return `<li><a href="${sHref}">${sTitle}</a></li>`;
      }).join('');

      const uid = 'pp-sub-' + Math.random().toString(36).slice(2,9);
      return `
        <li class="pp-item has-children">
          <button class="pp-topbtn" aria-expanded="false" aria-controls="${uid}">
            <div><span>${title}</span>${subtitleHTML}</div>
            <i class="pp-caret" aria-hidden="true">▾</i>
          </button>
          <ul id="${uid}" class="pp-submenu" hidden>
            ${subLinks}
          </ul>
        </li>
      `;
    };

    let itemsHTML = '';
    if (topItems.length) {
      itemsHTML = topItems.map(buildItem).join('');
    } else {
      // Fallback
      const fallback = [
        { label: 'Hem',        href: '/',                          sub: 'Tillbaka till start' },
        { label: 'Kategorier', href: '/collections',               sub: 'Utforska vårt sortiment' },
        { label: 'Produkter',  href: '/collections/alla-produkter', sub: 'Utforska vårt sortiment' },
        { label: 'Om oss',    href: '/pages/om-oss',              sub: 'Vår historia & vision' },
        { label: 'Kontakta',  href: '/pages/kontakta',            sub: 'Hör av dig till oss' },
      ];
      itemsHTML = fallback.map(l =>
        `<li class="pp-item"><a class="pp-toplink" href="${l.href}"><div>${l.label}<span class="pp-menu-subtitle">${l.sub}</span></div></a></li>`
      ).join('');
    }

    ov.innerHTML = `
      <div class="pp-sweeps" aria-hidden="true"><span></span><span></span><span></span></div>
      <div class="pp-menu-content">
        <button class="pp-close" aria-label="Stäng meny">✕</button>
        <div class="pp-menu-logo">${logoSrc ? `<img src="${logoSrc}" alt="Pannproffsen AB">` : ''}</div>
        <ul class="pp-menu-list">${itemsHTML}</ul>
      </div>
    `;
    document.body.appendChild(ov);

    // Interactions
    ov.querySelector('.pp-close').addEventListener('click', closeOverlay);
    ov.addEventListener('click', (e) => {
      const content = ov.querySelector('.pp-menu-content');
      if (!content.contains(e.target)) closeOverlay();
    });

    // Stäng på länkklick
    ov.querySelectorAll('.pp-menu-list a').forEach(a => {
      a.addEventListener('click', closeOverlay, { passive: true });
    });

    // Toggle submenyer (accordion)
    ov.querySelectorAll('.pp-item.has-children .pp-topbtn').forEach(btn => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
          });
          panel.addEventListener('transitionend', () => {
            panel.hidden = true;
            panel.style.maxHeight = '';
          }, { once: true });
          btn.closest('.pp-item').classList.remove('is-open');
        } else {
          panel.hidden = false;
          panel.style.maxHeight = '0px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          panel.addEventListener('transitionend', () => {
            panel.style.maxHeight = '';
          }, { once: true });
          btn.closest('.pp-item').classList.add('is-open');
        }
      });
    });
  }

  // 3) Focus-trap + ESC
  function trapFocus(e) {
    const ov = document.getElementById('pp-menu-overlay');
    if (!ov || ov.getAttribute('aria-hidden') === 'true') return;
    const focusables = ov.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    } else if (e.key === 'Escape') { closeOverlay(); }
  }

  // 4) Open/Close
  function openOverlay(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    buildOverlay();

    const ov = document.getElementById('pp-menu-overlay');
    if (!ov) return;
    lastFocusEl = document.activeElement;

    const h = header ? header.offsetHeight : 64;
    ov.style.setProperty('--pp-header-h', h + 'px');

    document.documentElement.classList.add('pp-open');
    document.body.classList.add('pp-open');

    ov.setAttribute('aria-hidden', 'false');
    ov.classList.remove('animate-out');
    void ov.offsetWidth;
    ov.classList.add('animate-in');

    const firstLink = ov.querySelector('.pp-menu-list a, .pp-item.has-children .pp-topbtn');
    setTimeout(() => { firstLink && firstLink.focus(); }, 300);

    document.addEventListener('keydown', trapFocus);
  }

  function closeOverlay(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    const ov = document.getElementById('pp-menu-overlay');
    if (!ov) return;

    ov.classList.remove('animate-in');
    ov.classList.add('animate-out');
    ov.setAttribute('aria-hidden', 'true');

    const cleanup = () => {
      document.documentElement.classList.remove('pp-open');
      document.body.classList.remove('pp-open');
      document.removeEventListener('keydown', trapFocus);
      lastFocusEl && lastFocusEl.focus();
      ov.removeEventListener('animationend', cleanup);
      ov.removeEventListener('transitionend', cleanup);
    };
    ov.addEventListener('animationend', cleanup);
    ov.addEventListener('transitionend', cleanup);
  }

  // 5) Koppla hamburgaren
  if (hamburger) {
    hamburger.addEventListener('click', openOverlay);
  }

  document.addEventListener('shopify:section:load', setHeaderState);

})();

// === PP: Hook endast på /collections ===
(function () {
  function ready(fn){ if (document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn, {once:true}); }

  ready(() => {
    if (!/^\/collections\/?$/.test(location.pathname)) return;
    document.body.classList.add('pp-collections-page');

    const links = Array.from(document.querySelectorAll('a[href^="/collections/"]'));
    if (links.length < 3) return;

    let node = links[0];
    while (node && node !== document.body) {
      if (node.matches('.collection-list, .grid, .row, section, ul, ol, div')) {
        node.id = 'pp-collections';
        break;
      }
      node = node.parentElement;
    }
  });
})();
